import { render, staticRenderFns } from "./credit-list.vue?vue&type=template&id=cf4bb60c"
import script from "./credit-list.vue?vue&type=script&lang=ts"
export * from "./credit-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports